module.exports = __webpack_public_path__ + "img/a2.0420f422.png";